/**
 * Sanitize dynamic URL path segments (ids, slugs) before API calls.
 */

export const sanitizePathSegment = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

export const isValidPathSegment = (value) => {
  const safe = sanitizePathSegment(value);
  return safe !== "" && !/\s/.test(safe);
};

export const assertValidPathSegment = (value, label = "id") => {
  const safe = sanitizePathSegment(value);
  if (!isValidPathSegment(safe)) {
    throw new Error(`Invalid ${label} for API request`);
  }
  return safe;
};
